import {
  createRouter,
  createWebHistory,
  type RouteRecordRaw,
} from "vue-router";
import { getToken } from "@/utils/auth";
import Layout from "@/layout/index.vue";
import { home, productsBtnMap } from "./menus/home";
import { openAccount } from "./menus/openAccount";
import { adAccount } from "./menus/adAccount";
import { fundManage } from "./menus/fundManage";
import { dataCenter } from "./menus/dataCenter";
import { permission } from "./menus/permission";
import { helpCenter } from "./menus/helpcenter";
export const constantRoutes: any[] = [
  ...home, // 商品管理
  ...openAccount,
  ...adAccount,
  ...fundManage,
  ...dataCenter,
  ...permission,
  ...helpCenter,
];

export const homeRouter = {
  path: "/",
  name: "Home",
  component: Layout,
  redirect: "",
  children: [],
};

export const constantRoutesOther: RouteRecordRaw[] = [
  {
    path: "/login",
    component: () => import("../views/login/index.vue"),
    name: "Login",
    meta: {
      hidden: true,
      title: "登录",
    },
  },
  {
    path: "/",
    name: "Layout",
    component: Layout,
    redirect: "/home",
    children: [
      ...home,
      ...openAccount,
      ...adAccount,
      ...fundManage,
      ...dataCenter,
      ...permission,
      ...helpCenter,
    ],
  },
  {
    path: "/404",
    component: () => import("../views/error/404.vue"),
    name: "NoFind",
    meta: {
      hidden: true,
      title: "",
    },
  },
  {
    path: "/403",
    component: () => import("../views/error/403.vue"),
    name: "NoAuth",
    meta: {
      hidden: true,
      title: "",
    },
  },
  {
    path: "/500",
    component: () => import("../views/error/500.vue"),
    name: "ServerError",
    meta: {
      hidden: true,
      title: "",
    },
  },
  {
    path: "/server-term",
    component: () => import("../views/serverPrivacy/server.vue"),
    name: "服务条款",
    meta: {
      hidden: true,
      title: "",
    },
  },
  {
    path: "/privacy-policy",
    component: () => import("../views/serverPrivacy/privacyPolicy.vue"),
    name: "隐私政策",
    meta: {
      hidden: true,
      title: "",
    },
  },
  {
    path: "/:pathMatch(.*)", // 匹配没有匹配的所有路由
    name: "pathMatch",
    redirect: "/404",
    meta: {
      hidden: true,
      title: "",
    },
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [...constantRoutesOther],
  // 刷新时，滚动条位置还原
  scrollBehavior: () => ({ left: 0, top: 0 }),
});
// 白名单
let witheList = ["/login", "/404", "/server-term", "/privacy-policy"];
router.beforeEach((to, from, next) => {
  const isLogin = !!getToken();

  if (!witheList.includes(to.path) && !isLogin) {
    next("/login"); // 如果未登录且尝试访问非登录页，则重定向到登录页
  } else {
    next(); // 已登录或正在访问登录页
  }
});
export const btnAuthMap = {
  ...productsBtnMap,
};

export default router;
